<template>
  <div id="projet" class="screen-calc bg-white flex flex-col items-center md:p-6 p-3 overflow-hidden">
    <!-- Titre -->
    <Title title="Projets" />

    <!-- Boutons pour choisir la vue -->
    <div class="mt-8 flex justify-center flex-wrap gap-3 space-x-4 md:px-0 px-6">
      <button
        @click="currentView = 'home'"
        :class="[
          'px-6 py-3 font-semibold rounded-lg shadow-md transition-all duration-200 transform hover:scale-105',
          currentView === 'home' ? 'bg-cv text-white' : 'bg-white text-gray-700 hover:bg-gray-200',
        ]"
      >
        Home
      </button>
      <button
        @click="currentView = 'entreprise'"
        :class="[
          'px-6 py-3 font-semibold rounded-lg shadow-md transition-all duration-200 transform hover:scale-105',
          currentView === 'entreprise' ? 'bg-cv text-white' : 'bg-white text-gray-700 hover:bg-gray-200',
        ]"
      > 
        Projets entreprise
      </button>
      <button
        @click="currentView = 'social_media'"
        :class="[
          'px-6 py-3 font-semibold rounded-lg shadow-md transition-all duration-200 transform hover:scale-105',
          currentView === 'social_media' ? 'bg-cv text-white' : 'bg-white text-gray-700 hover:bg-gray-200',
        ]"
      > 
        Projets scolaires
      </button>
      <button
        @click="currentView = 'shooting'"
        :class="[
          'mb-3 md:mb-0 px-6 py-3 font-semibold rounded-lg shadow-md transition-all duration-200 transform hover:scale-105',
          currentView === 'shooting' ? 'bg-cv text-white' : 'bg-white text-gray-700 hover:bg-gray-200',
        ]"
      > 
        Shooting
      </button>
      

      
      <!-- <button
        @click="currentView = 'creation'"
        :class="[
          'px-6 py-3 font-semibold rounded-lg shadow-md transition-all duration-200 transform hover:scale-105',
          currentView === 'creation' ? 'bg-cv text-white' : 'bg-white text-gray-700 hover:bg-gray-200',
        ]"
      > 
        Creation
      </button> -->
    </div>

    <!-- Contenu avec transition smooth -->
    <div class="relative w-full max-w-6xl mt-8 min-h-[300px]"> 
  <transition name="slide" mode="out-in">
    <div :key="currentView" class="w-full flex flex-col items-center bg-white rounded-lg shadow-lg p-0 md:p-6">
      <h2 v-if="currentView === 'home'" class="text-2xl font-bold text-gray-800 p-2">
        Bienvenue, Voulez vous voir mes projets?
      </h2>
      <p v-if="currentView === 'home'" class="mt-4 text-gray-600 p-2">
        Ceci est un condensé des projets réalisés durant mes 2 premières années en bachelor communication.
      </p>

      <Shooting v-if="currentView === 'shooting'" />
      <SocialMedia v-if="currentView === 'social_media'" />
      <Entreprise v-if="currentView === 'entreprise'" />

      <Creation v-if="currentView === 'creation'" />

    </div>
  </transition>
</div>

  </div>
</template>

<script>
import Shooting from '@/components/shooting.vue';
import Title from '@/components/title.vue';
import SocialMedia from '@/components/social_media.vue';
import Creation from '@/components/creation.vue';
import Entreprise from '@/components/Entreprise.vue';

export default {
  name: 'App',
  components: {
    Shooting,
    Title,
    SocialMedia,
    Creation, 
    Entreprise,
  },
  data() {
    return {
      currentView: 'home',
    };
  },
};
</script>

<style scoped>
/* Transition smooth avec effet de glissement */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.slide-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.screen-calc {
  min-height: calc(100vh - 180px);
}
</style>
